"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveIcon = void 0;
var react_1 = __importDefault(require("react"));
var MoveIcon = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, version: "1.1", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { transform: "scale(1.6667)", fill: "none", stroke: "#000", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5" },
            react_1.default.createElement("path", { d: "m9 3.748 3-3 3 3" }),
            react_1.default.createElement("path", { d: "m15 20.248-3 3-3-3" }),
            react_1.default.createElement("path", { d: "m12 0.748v22.5" }),
            react_1.default.createElement("path", { d: "m3.75 14.998-3-3 3-3" }),
            react_1.default.createElement("path", { d: "m20.25 8.998 3 3-3 3" }),
            react_1.default.createElement("path", { d: "m0.75 11.998h22.5" }))));
};
exports.MoveIcon = MoveIcon;
